export const mergeUniqueTracks = (existing, incoming) => {
  const seen = new Set();
  return [...existing, ...incoming].filter(track => {
    const key = track?.id || track?.uri;
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const nextSearchOffset = page => {
  const offset = Number(page?.offset) || 0;
  const limit = Number(page?.limit) || 10;
  return offset + limit;
};

export const isNearScrollEnd = element => (
  element.scrollHeight - element.scrollTop - element.clientHeight < 320
);

export const createSearchRequestTracker = () => {
  let generation = 0;
  let activeQuery = '';
  let loading = false;

  return {
    reset(query) {
      generation += 1;
      activeQuery = query;
      loading = false;
      return generation;
    },
    isCurrent(query, requestGeneration) {
      return query === activeQuery && requestGeneration === generation;
    },
    tryStart(query, requestGeneration) {
      if (loading || !this.isCurrent(query, requestGeneration)) return false;
      loading = true;
      return true;
    },
    finish(requestGeneration) {
      if (requestGeneration === generation) loading = false;
    },
    isLoading() { return loading; },
    currentGeneration() { return generation; }
  };
};
